import React, { ReactNode } from "react";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { useLocation } from "react-router-dom";

interface LayoutProps {
	children: ReactNode;
}

const Layout: React.FC<LayoutProps> = (props) => {
	const { pathname } = useLocation();
	const onboardingLinks = [
		"/login",
		"/register",
		"/forgot-password",
		"/reset-password",
		"/otp",
	];

	const hideHeaderFooter =
		onboardingLinks.includes(pathname) ||
		pathname.startsWith("/ext-court-live-session") ||
		pathname.startsWith("/court-live-session") ||
		pathname.startsWith("/public-hearing");

	return (
		<div>
			{!hideHeaderFooter && <Header />}
			{props.children}
			{!hideHeaderFooter && <Footer />}
		</div>
	);
};

export default Layout;
